import { Button, DatePicker, Form, Input, Space } from "antd";
import { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import { useCallback, useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import EditIcon from "../../../assets/icons/EditIcon";
import EyeIcon from "../../../assets/icons/EyeIcon";
import { IMAGE_URL } from "../../../helpers/config";
import { addKeyInArray } from "../../../helpers/siteConfig";
import useModal from "../../../hooks/useModal";
import {
  forwardRequestToStepAboveAsync,
  getAllBatchmentPaymentAsync,
  getGeneratePdfAsync,
  markPaidPaymentAsync,
  rejectBatchPaymentAsync,
  updateBatchPaymentAsync,
} from "../../../store/features/NP/supplier/supplierAPI";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import { CustomTableProps, ModalType } from "../../../types";
import {
  GetAllBatchmentPaymentData,
  GetAllBatchmentPaymentParams,
} from "../../../types/redux/NP/supplier";
import { stringToArray } from "../../../utils/array";
import { countParPageSerialNumber } from "../../../utils/number";
import { capitalize } from "../../../utils/string";
import ConfirmModal from "../../common/ConfirmModal";
import CustomTable from "../../common/CustomTable";
import ImportPaymentInvoiceModal from "../Network/ImportPaymentInvoiceModal";
import ImportPdf from "../Network/ImportPdf";
import {
  formatDate,
  formatDateNotNew,
  formatTimeNotNew,
} from "../../../utils/time";
import { toast } from "../../../helpers/toast";
import AXIOS from "../../../helpers/api";
import { BASE_API } from "../../../helpers/apiUrl";
import moment from "moment";
import ImportExcel from "../Network/ImportExcel";
import ImportFinanceExcel from "../Network/ImportFinanceExcel";
import Loader from "../../common/Loader";

type Props = {
  keyword?: string;
  downloadExcel: (data: any[]) => void;
  handleExcelLoading: (val: boolean) => void;
  downloadClicked: boolean;
  setDownloadClicked: (val: boolean) => void;
  openImportExcel?: ModalType;
  toggleImportExcel: () => void;
  filter?: {
    regionId?: string;
    areaId?: string;
    territoryId?: string;
    poNumber?: any;
    trackingNumber?: any;
    statusFilter?: any;
  };
} & CustomTableProps;

export default function BatchPaymentTable({
  keyword = "",
  page,
  limit,
  isFirstPage,
  filter,
  handlePagination,
  handleSetFirstPage,
  downloadExcel,
  handleExcelLoading,
  downloadClicked,
  setDownloadClicked,
  openImportExcel,
  toggleImportExcel,
}: Props) {
  const dispatch = useAppDispatch();
  const [uploadCount, setUploadCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [reason, setReason] = useState("");
  const invoiceRef = useRef<HTMLDivElement>(null);
  const [loadingId, setLoadingId] = useState<string | null>(null);
  const location = useLocation();
  const path = stringToArray(location.pathname, "/")?.[0];
  const [selectedData, setSelectedData] = useState<string[]>([]);
  const [viewStateLoading, setViewStateLoading] = useState<string | null>(null);

  const {
    open: confirmOpen,
    toggle: confirmToggle,
    handleOpen: handleConfirmOpen,
  } = useModal();
  const {
    open: openImport,
    toggle: toggleImport,
    handleOpen: handleOpenImport,
  } = useModal();
  const {
    open: addGROpen,
    toggle: addGRToggle,
    handleOpen: handleAddGROpen,
  } = useModal();

  const [form] = Form.useForm();
  const { login } = useAppSelector((state) => state.login);

  const {
    loading,
    postLoading,
    allBatchmentPayment,
    generateInvoice,
    getGeneratePdfData,
    viewLoading,
  } = useAppSelector((state) => state.supplier);

  const uploadedCount = (value: number, total: number) => {
    setUploadCount(value);
    setTotalCount(total);
  };

  const handleRequest = (data: any) => {
    if (confirmOpen?.type === "PAYMENT_REQUEST" && login?.role === "vendor") {
      const newValues = {
        remarkText: "Forwarding to next role",
      };

      dispatch(
        forwardRequestToStepAboveAsync({
          data: newValues,
          others: {
            reRender,
            id: data?._id,
            role: login?.role,
          },
        })
      );
    }

    if (
      confirmOpen?.type === "FORWARD_TO_CLUSTER_HEAD" &&
      login?.role === "region"
    ) {
      const newValues = {
        remarkText: "Forwarding to next role",
      };

      dispatch(
        forwardRequestToStepAboveAsync({
          data: newValues,
          others: {
            reRender,
            id: data?._id,
            role: login?.role,
          },
        })
      );
    }

    if (
      confirmOpen?.type === "FORWARD_TO_ENERGY_OPS" &&
      login?.role === "cluster"
    ) {
      const newValues = {
        remarkText: "Forwarding to next role",
      };

      dispatch(
        forwardRequestToStepAboveAsync({
          data: newValues,
          others: {
            reRender,
            id: data?._id,
            role: login?.role,
          },
        })
      );
    }

    if (
      confirmOpen?.type === "FORWARD_TO_DIRECTOR_OF_OPS" &&
      login?.role === "energyOps"
    ) {
      const newValues = {
        remarkText: "Forwarding to next role",
      };

      dispatch(
        forwardRequestToStepAboveAsync({
          data: newValues,
          others: {
            reRender,
            id: data?._id,
            role: login?.role,
          },
        })
      );
    }

    if (
      confirmOpen?.type === "FORWARD_TO_GR" &&
      login?.role === "directorOps"
    ) {
      const newValues = {
        remarkText: "Forwarding to next role",
      };

      dispatch(
        forwardRequestToStepAboveAsync({
          data: newValues,
          others: {
            reRender,
            id: data?._id,
            role: login?.role,
          },
        })
      );
    }

    if (confirmOpen?.type === "PAYMENT" && login?.role === "finance") {
      const newValues = {
        remarkText: "Forwarding to next role",
      };

      dispatch(
        markPaidPaymentAsync({
          data: newValues,
          others: {
            reRender,
            id: data?._id,
            role: login?.role,
          },
        })
      );
    }
  };

  const handleReject = (data: any) => {
    if (confirmOpen?.type === "REJECT" && login?.role === "region") {
      const newValues = {
        remarkText: reason,
      };

      dispatch(
        rejectBatchPaymentAsync({
          data: newValues,
          others: {
            reRender,
            id: data?._id,
          },
        })
      );
    }

    if (confirmOpen?.type === "REJECT" && login?.role === "cluster") {
      const newValues = {
        remarkText: reason,
      };

      dispatch(
        rejectBatchPaymentAsync({
          data: newValues,
          others: {
            reRender,
            id: data?._id,
          },
        })
      );
    }

    if (confirmOpen?.type === "REJECT" && login?.role === "energyOps") {
      const newValues = {
        remarkText: reason,
      };

      dispatch(
        rejectBatchPaymentAsync({
          data: newValues,
          others: {
            reRender,
            id: data?._id,
          },
        })
      );
    }

    if (confirmOpen?.type === "REJECT" && login?.role === "directorOps") {
      const newValues = {
        remarkText: reason,
      };

      dispatch(
        rejectBatchPaymentAsync({
          data: newValues,
          others: {
            reRender,
            id: data?._id,
          },
        })
      );
    }

    if (confirmOpen?.type === "REJECT" && login?.role === "gr") {
      const newValues = {
        remarkText: reason,
      };

      dispatch(
        rejectBatchPaymentAsync({
          data: newValues,
          others: {
            reRender,
            id: data?._id,
          },
        })
      );
    }

    if (confirmOpen?.type === "REJECT" && login?.role === "finance") {
      const newValues = {
        remarkText: reason,
      };

      dispatch(
        rejectBatchPaymentAsync({
          data: newValues,
          others: {
            reRender,
            id: data?._id,
          },
        })
      );
    }
  };

  const handleGRNumber = (values: any) => {
    dispatch(
      updateBatchPaymentAsync({
        data: values,
        others: {
          reRender,
          id: addGROpen?.data?._id,
          role: login?.role,
        },
      })
    );
  };

  const handleGeneratePDF = (id: string) => {
    setViewStateLoading(id);
    dispatch(
      getGeneratePdfAsync({
        params: { id },
        others: {
          reRender: () => {
            setTimeout(() => {
              getAllBatchmentPaymentData();
              setViewStateLoading(null);
            }, 3000);
          },
        },
      })
    );
  };

  const getAllBatchmentPaymentData = useCallback(() => {
    const limitParams: GetAllBatchmentPaymentParams = {
      limit: limit,
      // skip: limit * (page - 1),
      page: page,
    };

    const searchParams: GetAllBatchmentPaymentParams = {
      batchName: keyword,
    };

    const baseParams = keyword ? searchParams : limitParams;

    const params: GetAllBatchmentPaymentParams = {
      ...baseParams,
      zone: filter?.areaId ? filter?.areaId : undefined,
      cluster: filter?.regionId ? filter?.regionId : undefined,
      status: filter?.statusFilter ? filter?.statusFilter : undefined,
      // suppler: login?.suppler,
      suppler: "",
      irTrackingNumber: filter?.trackingNumber
        ? filter?.trackingNumber
        : undefined,
      po: filter?.poNumber ? filter?.poNumber : undefined,
    };

    if (filter?.regionId) {
      dispatch(
        getAllBatchmentPaymentAsync({
          params: params,
        })
      );
    }
  }, [
    dispatch,
    keyword,
    limit,
    page,
    filter?.trackingNumber,
    filter?.poNumber,
    filter?.regionId,
    filter?.areaId,
    filter?.statusFilter,
  ]);

  useEffect(() => {
    getAllBatchmentPaymentData();
  }, [getAllBatchmentPaymentData]);

  const columns: ColumnsType<GetAllBatchmentPaymentData> = [
    // ...(path === "finance"
    //   ? [
    //       {
    //         title: "#SL",
    //         align: "center" as const,
    //         width: 60,
    //         render: (_: unknown, __: unknown, index: number) =>
    //           countParPageSerialNumber(page, limit, index),
    //       },
    //     ]
    //   : []),
    {
      title: "#SL",
      align: "center" as const,
      width: 60,
      render: (_: unknown, __: unknown, index: number) =>
        countParPageSerialNumber(page, limit, index),
    },
    {
      title: "Batch Name",
      dataIndex: "batchName",
      align: "center",
      render: (val) => (val ? val : "N/A"),
    },
    // {
    //   title: "Vendor Name",
    //   dataIndex: "vendor",
    //   align: "center",
    //   render: (val) => (val ? `${val?.firstName} ${val?.lastName}` : "N/A"),
    // },
    {
      title: "Supplier Name",
      dataIndex: "suppler",
      align: "center",
      render: (val) => (val ? `${val?.supplierName}` : "N/A"),
    },
    {
      title: "PO Number",
      dataIndex: "po",
      align: "center",
      render: (val) => (val?.PONumber ? val?.PONumber : "N/A"),
    },

    {
      title: "Tracking Number",
      dataIndex: "invoiceNo",
      align: "center",
      render: (val) => (val ? val : "N/A"),
    },

    {
      title: "Invoice Date",
      dataIndex: "invoiceGenerateDate",
      align: "center",
      render: (val) => (val ? formatDate(val) : "N/A"),
    },

    {
      title: "Invoice",
      align: "center",
      render: (_: any, record: any) => (
        <>
          {record?.invoiceUrl ? (
            <>
              <a
                href={record?.invoiceUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="cursor-pointer underline text-blue-600"
              >
                View Invoice
              </a>
            </>
          ) : (
            <>
              <Button
                className="cursor-pointer underline"
                onClick={() => handleGeneratePDF(record?._id)}
                loading={viewStateLoading === record?._id && viewLoading}
              >
                Generate
              </Button>
            </>
          )}
        </>
      ),
    },

    {
      title: "Transaction Id",
      dataIndex: "irJBN",
      align: "center",
      render: (val) => (val ? val : "N/A"),
    },

    {
      title: "Total Site",
      dataIndex: "totalUniqueSite",
      align: "center",
      render: (val) => (val ? val : "0"),
    },
    {
      title: "Total TT",
      dataIndex: "totalTicket",
      align: "center",
      render: (val) => (val ? val : "0"),
    },
    {
      title: "Total PGRH",
      dataIndex: "totalWorkingHrs",
      align: "center",
      render: (val) => (val ? val : "0"),
    },
    {
      title: "Total Amount",
      dataIndex: "totalAmount",
      align: "center",
      render: (val: string | number) =>
        val ? Number(val).toLocaleString("en-US") : "0",
    },
    {
      title: "VAT 6.3",
      dataIndex: "vat",
      align: "center",
      render: (val: string, record: any) =>
        val && val !== "Add" ? (
          <>
            <a
              href={IMAGE_URL + val}
              download
              target="_blank"
              className="max-w-[200px] block overflow-hidden text-ellipsis whitespace-nowrap"
              rel="noreferrer"
            >
              {val}
            </a>
          </>
        ) : (
          <Button
            type="link"
            onClick={() =>
              handleOpenImport({
                type: "IMPORT",
                data: record,
              })
            }
          >
            Add
          </Button>
        ),
    },

    ...(login?.role !== "vendor"
      ? [
          {
            title: "GR Number",
            dataIndex: "grInput",
            align: "center" as "center",
            render: (val: string, record: any) =>
              val && val !== "Add" ? (
                <div>{val}</div>
              ) : (
                <>
                  {/* <Button
                  type="link"
                  onClick={() =>
                    handleAddGROpen({
                      type: "ADD_GR_NUMBER",
                      data: record,
                    })
                  }
                >
                  Add GR Number
                    </Button> */}
                  <div>N/A</div>
                </>
              ),
          },
          {
            title: "GR Date",
            dataIndex: "grDate",
            align: "center" as "center",
            render: (val: string) => (val ? formatDate(val) : "N/A"),
          },
          {
            title: "GR Amount",
            dataIndex: "grAmount",
            align: "center" as "center",
            render: (val: string | number) =>
              val ? Number(val).toLocaleString("en-US") : "0",
          },
        ]
      : []),

    {
      title: "Status",
      dataIndex: "status",
      align: "center",
      render: (val: string) => {
        // Common base button styles
        const baseClass =
          "px-3 py-1 rounded inline-flex flex-col justify-center items-center gap-[3px] text-sm font-normal border-none hover:border-none focus:outline-none focus:ring-0 shadow-none";

        // Conditional classes
        let statusClass = "";
        let label = "";

        switch (val) {
          case "draft":
            statusClass = "bg-blue-100 text-blue-600";
            label = "Draft";
            break;
          case "passed":
            statusClass = "bg-green-100 text-green-600";
            label = "passed";
            break;
          case "paid":
            statusClass = "bg-green-100 text-green-600";
            label = "Paid";
            break;
          case "pending":
            statusClass = "bg-slate-100 text-slate-600";
            label = "Pending";
            break;
          case "rejected":
            statusClass = "bg-red-50 text-red-500";
            label = "Rejected";
            break;
          case "complete":
            statusClass = "bg-violet-50 text-blue-600";
            label = "Complete";
            break;
          case "processing":
            statusClass = "bg-yellow-50 text-yellow-500";
            label = "Processing";
            break;
          default:
            return capitalize(val);
        }

        return (
          <div className={`${baseClass} ${statusClass}`}>
            {capitalize(label)}
          </div>
        );
      },
    },

    // {
    //   title: "Zonal Head",
    //   dataIndex: "remarks",
    //   align: "center" as const,
    //   render: (remarks: any[]) => {
    //     if (!Array.isArray(remarks)) return "N/A";
    //     // Find the remark with role === "energyOps"
    //     const clusterRemark = remarks.find((r) => r.role === "gr");

    //     if (!clusterRemark) return "N/A";

    //     const status = clusterRemark.status?.toLowerCase();

    //     // Common base button styles
    //     const baseClass =
    //       "px-3 py-1 rounded inline-flex flex-col justify-center items-center gap-[3px] text-sm font-normal border-none hover:border-none focus:outline-none focus:ring-0 shadow-none";

    //     // Conditional classes
    //     let statusClass = "";
    //     let label = "";

    //     switch (status) {
    //       case "passed":
    //         statusClass = "bg-teal-50 text-green-600";
    //         label = "Approved";
    //         break;
    //       case "rejected":
    //         statusClass = "bg-red-50 text-red-500";
    //         label = "Rejected";
    //         break;
    //       case "complete":
    //         statusClass = "bg-violet-50 text-blue-600";
    //         label = "Complete";
    //         break;
    //       default:
    //         return status; // return raw value if no match
    //     }

    //     return <div className={`${baseClass} ${statusClass}`}>{label}</div>;
    //   },
    // },

    ...(login?.role === "vendor"
      ? []
      : [
          // {
          //   title: "Cluster Head",
          //   dataIndex: "remarks", // still accessing the full array
          //   align: "center" as const,
          //   render: (remarks: any[]) => {
          //     if (!Array.isArray(remarks)) return "N/A";

          //     // Find the remark with role === "cluster"
          //     const clusterRemark = remarks.find((r) => r.role === "cluster");

          //     if (!clusterRemark) return "N/A";

          //     const status = clusterRemark.status?.toLowerCase();

          //     // Common base button styles
          //     const baseClass =
          //       "px-3 py-1 rounded inline-flex flex-col justify-center items-center gap-[3px] text-sm font-normal border-none hover:border-none focus:outline-none focus:ring-0 shadow-none";

          //     let statusClass = "";
          //     let label = "";

          //     switch (status) {
          //       case "passed":
          //         statusClass = "bg-teal-50 text-green-600";
          //         label = "Approved";
          //         break;
          //       case "rejected":
          //         statusClass = "bg-red-50 text-red-500";
          //         label = "Rejected";
          //         break;
          //       case "complete":
          //         statusClass = "bg-violet-50 text-blue-600";
          //         label = "Complete";
          //         break;
          //       default:
          //         return status; // show the raw status if not matched
          //     }

          //     return (
          //       <div className={`${baseClass} ${statusClass}`}>
          //         {capitalize(label)}
          //       </div>
          //     );
          //   },
          // },

          // {
          //   title: "Energy Ops",
          //   dataIndex: "remarks",
          //   align: "center" as const,
          //   render: (remarks: any[]) => {
          //     if (!Array.isArray(remarks)) return "N/A";
          //     // Find the remark with role === "energyOps"
          //     const clusterRemark = remarks.find((r) => r.role === "energyOps");

          //     if (!clusterRemark) return "N/A";

          //     const status = clusterRemark.status?.toLowerCase();

          //     // Common base button styles
          //     const baseClass =
          //       "px-3 py-1 rounded inline-flex flex-col justify-center items-center gap-[3px] text-sm font-normal border-none hover:border-none focus:outline-none focus:ring-0 shadow-none";

          //     // Conditional classes
          //     let statusClass = "";
          //     let label = "";

          //     switch (status) {
          //       case "passed":
          //         statusClass = "bg-teal-50 text-green-600";
          //         label = "Approved";
          //         break;
          //       case "rejected":
          //         statusClass = "bg-red-50 text-red-500";
          //         label = "Rejected";
          //         break;
          //       case "complete":
          //         statusClass = "bg-violet-50 text-blue-600";
          //         label = "Complete";
          //         break;
          //       default:
          //         return status; // return raw value if no match
          //     }

          //     return (
          //       <div className={`${baseClass} ${statusClass}`}>
          //         {capitalize(label)}
          //       </div>
          //     );
          //   },
          // },
          // {
          //   title: "Director Ops",
          //   dataIndex: "remarks",
          //   align: "center" as const,
          //   render: (remarks: any[]) => {
          //     if (!Array.isArray(remarks)) return "N/A";
          //     // Find the remark with role === "energyOps"
          //     const clusterRemark = remarks.find(
          //       (r) => r.role === "directorOps"
          //     );

          //     if (!clusterRemark) return "N/A";

          //     const status = clusterRemark.status?.toLowerCase();

          //     // Common base button styles
          //     const baseClass =
          //       "px-3 py-1 rounded inline-flex flex-col justify-center items-center gap-[3px] text-sm font-normal border-none hover:border-none focus:outline-none focus:ring-0 shadow-none";

          //     // Conditional classes
          //     let statusClass = "";
          //     let label = "";

          //     switch (status) {
          //       case "passed":
          //         statusClass = "bg-teal-50 text-green-600";
          //         label = "Approved";
          //         break;
          //       case "rejected":
          //         statusClass = "bg-red-50 text-red-500";
          //         label = "Rejected";
          //         break;
          //       case "complete":
          //         statusClass = "bg-violet-50 text-blue-600";
          //         label = "Complete";
          //         break;
          //       default:
          //         return status; // return raw value if no match
          //     }

          //     return (
          //       <div className={`${baseClass} ${statusClass}`}>
          //         {capitalize(label)}
          //       </div>
          //     );
          //   },
          // },
          {
            title: "GR",
            dataIndex: "remarks",
            align: "center" as const,
            render: (remarks: any[]) => {
              if (!Array.isArray(remarks)) return "N/A";
              // Find the remark with role === "energyOps"
              const clusterRemark = remarks.find((r) => r.role === "gr");

              if (!clusterRemark) return "N/A";

              const status = clusterRemark.status?.toLowerCase();

              // Common base button styles
              const baseClass =
                "px-3 py-1 rounded inline-flex flex-col justify-center items-center gap-[3px] text-sm font-normal border-none hover:border-none focus:outline-none focus:ring-0 shadow-none";

              // Conditional classes
              let statusClass = "";
              let label = "";

              switch (status) {
                case "passed":
                  statusClass = "bg-teal-50 text-green-600";
                  label = "Approved";
                  break;
                case "rejected":
                  statusClass = "bg-red-50 text-red-500";
                  label = "Rejected";
                  break;
                case "complete":
                  statusClass = "bg-violet-50 text-blue-600";
                  label = "Complete";
                  break;
                default:
                  return status; // return raw value if no match
              }

              return (
                <div className={`${baseClass} ${statusClass}`}>
                  {capitalize(label)}
                </div>
              );
            },
          },
          {
            title: "Finance",
            dataIndex: "remarks",
            align: "center" as const,
            render: (remarks: any[]) => {
              if (!Array.isArray(remarks)) return "N/A";
              // Find the remark with role === "energyOps"
              const clusterRemark = remarks.find((r) => r.role === "finance");

              if (!clusterRemark) return "N/A";

              const status = clusterRemark.status?.toLowerCase();

              // Common base button styles
              const baseClass =
                "px-3 py-1 rounded inline-flex flex-col justify-center items-center gap-[3px] text-sm font-normal border-none hover:border-none focus:outline-none focus:ring-0 shadow-none";

              // Conditional classes
              let statusClass = "";
              let label = "";

              switch (status) {
                case "passed":
                  statusClass = "bg-teal-50 text-green-600";
                  label = "Approved";
                  break;
                case "rejected":
                  statusClass = "bg-red-50 text-red-500";
                  label = "Rejected";
                  break;
                case "complete":
                  statusClass = "bg-violet-50 text-blue-600";
                  label = "Complete";
                  break;
                default:
                  return status; // return raw value if no match
              }

              return (
                <div className={`${baseClass} ${statusClass}`}>
                  {capitalize(label)}
                </div>
              );
            },
          },
          {
            title: "Payment Status",
            align: "center" as const,
            render: (_: any, val: any) => {
              const remarks = val?.remarks;
              if (!Array.isArray(remarks)) return "N/A";

              // Find the remark with role === "finance"
              const clusterRemark = remarks.find((r) => r.role === "finance");
              if (!clusterRemark) return "N/A";

              const status = clusterRemark.status?.toLowerCase();

              const baseClass =
                "px-3 py-1 rounded inline-flex flex-col justify-center items-center gap-[3px] text-sm font-normal border-none hover:border-none focus:outline-none focus:ring-0 shadow-none";

              let statusClass = "";
              let label = "";

              // New condition
              if (
                status === "passed" &&
                val?.status?.toLowerCase() === "paid"
              ) {
                statusClass = "bg-teal-50 text-green-600";
                label = "Paid";
              } else {
                statusClass = "bg-slate-100 text-slate-600";
                label = "Pending";
              }

              return (
                <div className={`${baseClass} ${statusClass}`}>
                  {capitalize(label)}
                </div>
              );
            },
          },
        ]),

    {
      title: "Action",
      align: "center" as const,
      dataIndex: "paid",
      render: (_: any, record: any) => {
        const role = login?.role;
        const dynamicId = record._id;

        const getDetailsUrl = () => {
          if (role === "region") {
            return `/regional/payment/batch-payment/details/${dynamicId}`;
          } else if (role === "vendor") {
            return `/vendor/payment/batch-payment/details/${dynamicId}`;
          } else if (role === "cluster") {
            return `/cluster-ops/payment/details/${dynamicId}`;
          } else if (role === "energyOps") {
            return `/energy-ops/payment/details/${dynamicId}`;
          } else if (role === "directorOps") {
            return `/director-ops/payment/details/${dynamicId}`;
          } else if (role === "gr") {
            return `/gr-ops/payment/details/${dynamicId}`;
          } else if (role === "finance") {
            return `/finance/payment/details/${dynamicId}`;
          }
          return "#";
        };

        return (
          <div className="flex items-center justify-start gap-2">
            {/* {role === "vendor" && (
              <Link to={`/vendor/payment/batch-payment/task-list/${dynamicId}`}>
                <Button
                  type="default"
                  disabled={record?.status !== "draft"}
                  icon={<EditIcon />}
                />
              </Link>
            )} */}

            {(role === "region" ||
              role === "vendor" ||
              role === "cluster" ||
              role === "energyOps" ||
              role === "directorOps" ||
              role === "gr" ||
              role === "finance") && (
              <Link to={getDetailsUrl()}>
                <Button className="w-[100px] text-green-600 font-medium px-3 py-1.5 bg-teal-50 rounded-lg inline-flex justify-center items-center">
                  Details
                </Button>
              </Link>
            )}

            {/* {role === "vendor" && (
              <Button
                type="primary"
                disabled={
                  login?.role !== record?.currentRole ||
                  record?.status === "draft"
                }
                onClick={() =>
                  handleConfirmOpen({
                    type: "PAYMENT_REQUEST",
                    data: record,
                  })
                }
              >
                {record?.status === "draft" ||
                (record?.status === "processing" &&
                  record?.currentRole === "vendor")
                  ? " Payment Request"
                  : " Payment Requested"}
              </Button>
            )} */}

            {/* 
            {role === "region" && (
              <>
                <Button
                  type="primary"
                  disabled={
                    (login?.role === "region" &&
                      record?.currentRole !== "zone") ||
                    record?.status === "rejected"
                  }
                  onClick={() =>
                    handleConfirmOpen({
                      type: "FORWARD_TO_CLUSTER_HEAD",
                      data: record,
                    })
                  }
                >
                  Forward to Cluster Head
                </Button>

                <Button
                  disabled={
                    record?.status === "rejected" ||
                    (login?.role === "region" && record?.currentRole !== "zone")
                  }
                  onClick={() =>
                    handleConfirmOpen({
                      type: "REJECT",
                      data: record,
                    })
                  }
                  className="px-3.5 py-2 !bg-red-500 !text-white text-sm font-medium inline-flex items-center !border-none 
      hover:!bg-red-600 hover:!text-white hover:!border-none focus:!outline-none"
                >
                  Reject
                </Button>
              </>
            )} */}
            {/* 
            {role === "cluster" && (
              <>
                <Button
                  type="primary"
                  disabled={
                    login?.role !== record?.currentRole ||
                    record?.status === "rejected"
                  }
                  onClick={() =>
                    handleConfirmOpen({
                      type: "FORWARD_TO_ENERGY_OPS",
                      data: record,
                    })
                  }
                >
                  Forward to Energy Ops
                </Button>

                <Button
                  disabled={
                    record?.status === "rejected" ||
                    login?.role !== record?.currentRole
                  }
                  onClick={() =>
                    handleConfirmOpen({
                      type: "REJECT",
                      data: record,
                    })
                  }
                  className="px-3.5 py-2 !bg-red-500 !text-white text-sm font-medium inline-flex items-center !border-none 
      hover:!bg-red-600 hover:!text-white hover:!border-none focus:!outline-none"
                >
                  Reject
                </Button>
              </>
            )}

            {role === "energyOps" && (
              <>
                <Button
                  type="primary"
                  disabled={
                    login?.role !== record?.currentRole ||
                    record?.status === "rejected"
                  }
                  onClick={() =>
                    handleConfirmOpen({
                      type: "FORWARD_TO_DIRECTOR_OF_OPS",
                      data: record,
                    })
                  }
                >
                  Forward to Director of Ops
                </Button>
                <Button
                  disabled={
                    record?.status === "rejected" ||
                    login?.role !== record?.currentRole
                  }
                  onClick={() =>
                    handleConfirmOpen({
                      type: "REJECT",
                      data: record,
                    })
                  }
                  className="px-3.5 py-2 !bg-red-500 !text-white text-sm font-medium inline-flex items-center !border-none 
      hover:!bg-red-600 hover:!text-white hover:!border-none focus:!outline-none"
                >
                  Reject
                </Button>
              </>
            )}

            {role === "directorOps" && (
              <>
                <Button
                  type="primary"
                  disabled={
                    login?.role !== record?.currentRole ||
                    record?.status === "rejected"
                  }
                  onClick={() =>
                    handleConfirmOpen({
                      type: "FORWARD_TO_GR",
                      data: record,
                    })
                  }
                >
                  Forward to GR
                </Button>

                <Button
                  disabled={
                    record?.status === "rejected" ||
                    login?.role !== record?.currentRole
                  }
                  onClick={() =>
                    handleConfirmOpen({
                      type: "REJECT",
                      data: record,
                    })
                  }
                  className="px-3.5 py-2 !bg-red-500 !text-white text-sm font-medium inline-flex items-center !border-none 
      hover:!bg-red-600 hover:!text-white hover:!border-none focus:!outline-none"
                >
                  Reject
                </Button>
              </>
            )} */}

            {role === "gr" && (
              <>
                <Button
                  type="primary"
                  disabled={
                    login?.role !== record?.currentRole ||
                    record?.status === "rejected"
                  }
                  onClick={() =>
                    handleConfirmOpen({
                      type: "FORWARD_TO_FINANCE",
                      data: record,
                    })
                  }
                >
                  Forward to Finance
                </Button>

                <Button
                  disabled={
                    record?.status === "rejected" ||
                    login?.role !== record?.currentRole
                  }
                  onClick={() =>
                    handleConfirmOpen({
                      type: "REJECT",
                      data: record,
                    })
                  }
                  className="px-3.5 py-2 !bg-red-500 !text-white text-sm font-medium inline-flex items-center !border-none 
      hover:!bg-red-600 hover:!text-white hover:!border-none focus:!outline-none"
                >
                  Reject
                </Button>
              </>
            )}

            {role === "finance" && (
              <>
                <Button
                  type="primary"
                  disabled={
                    record?.status === "rejected" ||
                    record?.status === "passed" ||
                    record?.status === "paid" ||
                    login?.role !== record?.currentRole
                  }
                  onClick={() =>
                    handleConfirmOpen({
                      type: "PAYMENT",
                      data: record,
                    })
                  }
                >
                  Approve
                </Button>
                <Button
                  disabled={
                    record?.status === "rejected" ||
                    record?.status === "passed" ||
                    record?.status === "paid" ||
                    login?.role !== record?.currentRole
                  }
                  onClick={() =>
                    handleConfirmOpen({
                      type: "REJECT",
                      data: record,
                    })
                  }
                  className="px-3.5 py-2 !bg-red-500 !text-white text-sm font-medium inline-flex items-center !border-none 
      hover:!bg-red-600 hover:!text-white hover:!border-none focus:!outline-none"
                >
                  Reject
                </Button>
                <Link to={`/finance/payment/payment-summary/${record?._id}`}>
                  <Button icon={<EyeIcon />} />
                </Link>
              </>
            )}
          </div>
        );
      },
    },
  ];

  const onFinish = (values: any) => {
    const newData = {
      grInput: Number(values?.grInput),
      grAmount: Number(values?.grAmount),
      grDate: values?.grDate ? dayjs(values.grDate).format("DD-MM-YYYY") : null,
    };

    if (confirmOpen?.type === "FORWARD_TO_FINANCE" && login?.role === "gr") {
      dispatch(
        updateBatchPaymentAsync({
          data: newData,
          others: { reRender, id: confirmOpen?.data?._id },
        })
      )
        .unwrap()
        .then(() => {
          dispatch(
            forwardRequestToStepAboveAsync({
              data: {
                remarkText: "Forwarding to next role",
              },
              others: {
                reRender,
                id: confirmOpen?.data?._id,
                role: login?.role,
              },
            })
          );
        })
        .catch((error: any) => {
          console.error("Update batch payment failed:", error);
        });
    }
  };

  function reRender(val: boolean) {
    if (val) {
      toggleImport();
      confirmToggle();
      setReason("");
      getAllBatchmentPaymentData();
      form.resetFields();
      addGRToggle();
      toggleImportExcel();
    }
  }

  useEffect(() => {
    if (confirmOpen?.data?.totalAmount) {
      form.setFieldsValue({
        grAmount: confirmOpen.data.totalAmount,
      });
    }
  }, [confirmOpen, form]);

  // Excel Download
  useEffect(() => {
    if (downloadClicked) {
      const handleDownloadExcel = async () => {
        handleExcelLoading(true);
        let excelData = [] as any[];

        const limitParams: GetAllBatchmentPaymentParams = {
          limit: limit,
          // skip: limit * (page - 1),
          page: page,
        };

        const searchParams: GetAllBatchmentPaymentParams = {
          batchName: keyword,
        };

        const baseParams = keyword ? searchParams : limitParams;

        const params: GetAllBatchmentPaymentParams = {
          ...baseParams,
          zone: "",
          status: "",
          // suppler: login?.suppler,
          suppler: "",
        };
        await AXIOS.get(BASE_API.getAllBatchmentPayment, {
          params,
        })
          .then((res) => {
            const responseData = res?.data?.data;
            responseData?.forEach((el: any) => {
              let data = {} as any;
              const startTime =
                el?.towerTicketLogData?.pgAlert?.startTime?.time;
              const stopTime = el?.towerTicketLogData?.pgAlert?.stopTime?.time;
              const pgConnectTime = el?.towerTicketLogData?.pgStart?.time;
              const ttGenerateTime = el?.towerTicketLastData?.createdAt;

              const formattedStartTime = startTime
                ? moment(startTime, "hh:mm A").format("h:mm A")
                : "";
              const formattedStopTime = stopTime
                ? moment(stopTime, "hh:mm A").format("h:mm A")
                : "";
              const formattedPGConnectTime = pgConnectTime
                ? moment(pgConnectTime, "hh:mm A").format("h:mm A")
                : "-";
              const formattedTTGenerateDate =
                formatDateNotNew(ttGenerateTime) ?? "";

              const formattedTTGenerateTime =
                formatTimeNotNew(ttGenerateTime, "h:mm A") ?? "";

              data["Site Code"] = el?.siteCode ?? "-";
              data["Site Name"] = capitalize(el?.towerName) ?? "-";
              data["Region"] = el?.regionName ?? "-";
              data["Zone"] = el?.areaName ?? "-";
              data["MP"] = el?.teritoryName ?? "-";
              data[
                "Grid fail time"
              ] = `${formattedStartTime} - ${formattedStopTime}`;
              data["Site Status"] = el?.towerTicketLastData?.status
                ? capitalize(el?.towerTicketLastData?.status)
                : "-";
              data["PG Connect Time"] = formattedPGConnectTime;
              data["Tenant Name"] = el?.contactPersonName ?? "-";
              data["TT No"] = el?.numberOfOperation ?? 0;
              data[
                "TT Generate Time"
              ] = `${formattedTTGenerateDate} - ${formattedTTGenerateTime}`;
              data["TT Status"] = el?.towerTicketLastData?.status
                ? capitalize(el?.towerTicketLastData?.status)
                : "-";
              data["PG Status"] = el?.towerTicketLogData?.missCall
                ? "Missed Call"
                : el?.towerTicketLogData?.status
                ? capitalize(el?.towerTicketLogData?.status)
                : "-";

              excelData.push(data);
            });
          })
          .catch(() => {
            handleExcelLoading(false);
            toast("error", "Download fail! Please try again");
          });

        downloadExcel(excelData);
      };

      handleDownloadExcel();
      setDownloadClicked(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downloadClicked]);

  return (
    <>
      {openImportExcel?.type === "IMPORT_EXCEL" && (
        <ImportFinanceExcel
          open={openImportExcel.open}
          // data={open?.data}
          handleClose={toggleImportExcel}
          reRender={reRender}
          uploadedCount={uploadedCount}
        />
      )}

      {confirmOpen?.type === "REJECT" && (
        <ConfirmModal
          open={confirmOpen?.open}
          data={confirmOpen?.data}
          handleClose={confirmToggle}
          deleteLoading={loading}
          handleYes={() => {}}
          buttonText=""
          title={""}
          hideAlert={true}
          deleteTitle=""
          questionText=""
          buttonFooterBlank={true}
        >
          <div className="self-stretch justify-start !text-[#2D3643] text-xl font-semibold ">
            Are You Sure You Want to Reject?
          </div>
          <div className="self-stretch justify-start !text-[#2D3643] text-base font-normal mt-2  ">
            Are you sure you want to reject those payment? This won’t be undone.
          </div>

          <div className="mt-5">
            <Input
              placeholder="Tell Us Why"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </div>

          <div className="w-full justify-end flex gap-2 pt-6">
            <Button onClick={() => confirmToggle()} className="cancel_btn">
              Cancel
            </Button>
            <Button
              disabled={!reason.trim()}
              className={`px-3.5 py-2 text-sm font-medium inline-flex items-center !border-none focus:!outline-none
          ${
            reason.trim()
              ? "bg-red-500 text-white hover:!bg-red-600 hover:!text-white"
              : "bg-gray-300 text-gray-500 cursor-not-allowed"
          }`}
              onClick={() => handleReject(confirmOpen?.data)}
            >
              Reject
            </Button>
          </div>
        </ConfirmModal>
      )}

      {confirmOpen?.type === "PAYMENT" && (
        <ConfirmModal
          open={confirmOpen?.open}
          data={confirmOpen?.data}
          handleClose={confirmToggle}
          deleteLoading={loading}
          handleYes={handleRequest}
          buttonText="Approve"
          title={""}
          hideAlert={true}
          deleteTitle=""
          questionText=""
        >
          <div className="self-stretch justify-start !text-[#2D3643] text-xl font-semibold ">
            Are You Sure, You Want to Payment?
          </div>
          <div className="self-stretch justify-start !text-[#2D3643] text-base font-normal mt-2">
            Are you sure you want to approve this payment? This won't be undone.
          </div>
        </ConfirmModal>
      )}

      {confirmOpen?.type === "FORWARD_TO_FINANCE" && (
        <ConfirmModal
          open={confirmOpen?.open}
          data={confirmOpen?.data}
          handleClose={confirmToggle}
          deleteLoading={loading}
          handleYes={handleRequest}
          buttonText=""
          title={""}
          hideAlert={true}
          deleteTitle=""
          questionText=""
          buttonFooterBlank={true}
          width={600}
        >
          <div className="self-stretch justify-start !text-[#2D3643] text-xl font-semibold ">
            Are You Sure, You Want to Forward to Finance?
          </div>
          <div className="self-stretch justify-start !text-[#2D3643] text-base font-normal mt-2 mb-6">
            Are you sure you want to approve those payment? This won’t be
            undone. After clicking these payment goes to the Head of Energy Ops.
          </div>

          <Form
            className="custom-form hide_star_mark custom-gr-form"
            layout="vertical"
            onFinish={onFinish}
            size="large"
            form={form}
          >
            <Form.Item
              name="grInput"
              label="GR Number"
              rules={[
                {
                  required: true,
                  message: "Please enter gr number",
                },
                {
                  validator: (_, value) => {
                    if (value && value.includes(".")) {
                      return Promise.reject("GR Number can not be decimal");
                    }
                    if (value && Number(value) < 0) {
                      return Promise.reject("GR Number can not be negative");
                    }
                    if (value && !/^[0-9]+$/.test(value)) {
                      return Promise.reject(
                        "GR Number can not be letters or Character or Special Character"
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
              className="mb-4"
            >
              <Input
                size="large"
                placeholder="Enter account number"
                allowClear
                type="text"
              />
            </Form.Item>

            <Form.Item
              name="grDate"
              label="GR Date"
              className="mb-4"
              rules={[
                {
                  required: true,
                  message: "Please enter gr date",
                },
              ]}
            >
              <DatePicker
                className="w-full"
                disabledDate={(current) =>
                  current && current > moment().endOf("day")
                }
              />
            </Form.Item>

            <Form.Item
              name="grAmount"
              label="GR Amount"
              className="mb-4"
              rules={[
                {
                  required: true,
                  message: "Please enter gr amount",
                },
              ]}
            >
              <Input
                size="large"
                placeholder="Enter gr amount"
                allowClear
                disabled
              />
            </Form.Item>

            <div className="w-full justify-end flex gap-2 pt-6">
              <Button
                onClick={() => confirmToggle()}
                className="cancel_btn !bg-[#8897AE] !text-white !border-[2px] !border-transparent hover:!border-[#8897AE] transition-all duration-200"
              >
                Cancel
              </Button>
              <Button
                htmlType="submit"
                type="primary"
                // loading={deleteLoading}
                // disabled={disabled}
              >
                Approve
              </Button>
            </div>
          </Form>
        </ConfirmModal>
      )}

      {confirmOpen?.type === "FORWARD_TO_GR" && (
        <ConfirmModal
          open={confirmOpen?.open}
          data={confirmOpen?.data}
          handleClose={confirmToggle}
          deleteLoading={loading}
          handleYes={handleRequest}
          buttonText="Forward"
          title={""}
          hideAlert={true}
          deleteTitle=""
          questionText=""
        >
          <div className="self-stretch justify-start !text-[#2D3643] text-xl font-semibold ">
            Are You Sure, You Want to Forward to GR?
          </div>
          <div className="self-stretch justify-start !text-[#2D3643] text-base font-normal mt-2">
            Are you sure you want to approve this payment? This won't be undone.
          </div>
        </ConfirmModal>
      )}

      {confirmOpen?.type === "FORWARD_TO_DIRECTOR_OF_OPS" && (
        <ConfirmModal
          open={confirmOpen?.open}
          data={confirmOpen?.data}
          handleClose={confirmToggle}
          deleteLoading={loading}
          handleYes={handleRequest}
          buttonText="Forward"
          title={""}
          hideAlert={true}
          deleteTitle=""
          questionText=""
        >
          <div className="self-stretch justify-start !text-[#2D3643] text-xl font-semibold ">
            Are You Sure, You Want to Forward to Director of Ops?
          </div>
          <div className="self-stretch justify-start !text-[#2D3643] text-base font-normal mt-2">
            Are you sure you want to approve this payment? This won't be undone.
          </div>
        </ConfirmModal>
      )}

      {confirmOpen?.type === "FORWARD_TO_ENERGY_OPS" && (
        <ConfirmModal
          open={confirmOpen?.open}
          data={confirmOpen?.data}
          handleClose={confirmToggle}
          deleteLoading={loading}
          handleYes={handleRequest}
          buttonText="Forward"
          title={""}
          hideAlert={true}
          deleteTitle=""
          questionText=""
        >
          <div className="self-stretch justify-start !text-[#2D3643] text-xl font-semibold ">
            Are You Sure, You Want to Forward to Energy of Ops?
          </div>
          <div className="self-stretch justify-start !text-[#2D3643] text-base font-normal mt-2">
            Are you sure you want to approve this payment? This won't be undone.
          </div>
        </ConfirmModal>
      )}

      {confirmOpen?.type === "FORWARD_TO_CLUSTER_HEAD" && (
        <ConfirmModal
          open={confirmOpen?.open}
          data={confirmOpen?.data}
          handleClose={confirmToggle}
          deleteLoading={loading}
          handleYes={handleRequest}
          buttonText="Forward"
          title={""}
          hideAlert={true}
          deleteTitle=""
          questionText=""
        >
          <div className="self-stretch justify-start !text-[#2D3643] text-xl font-semibold ">
            Are You Sure, You Want to Forward it to Cluster Head?
          </div>
          <div className="self-stretch justify-start !text-[#2D3643] text-base font-normal mt-2">
            Are you sure you want to send this to Cluster Head? This won’t be
            undone. After clicking this payment goes to the Cluster Head.
          </div>
        </ConfirmModal>
      )}

      {confirmOpen?.type === "PAYMENT_REQUEST" && (
        <ConfirmModal
          open={confirmOpen?.open}
          data={confirmOpen?.data}
          handleClose={confirmToggle}
          deleteLoading={loading}
          handleYes={handleRequest}
          buttonText="Submit"
          title={""}
          hideAlert={true}
          deleteTitle=""
          questionText=""
        >
          <div className="self-stretch justify-start !text-[#2D3643] text-xl font-semibold ">
            Are You Sure, You Want to Payment Request?
          </div>
          <div className="self-stretch justify-start !text-[#2D3643] text-base font-normal mt-2">
            Are you sure you want to submit? This won't be undone. After
            clicking these payment goes to the Zonal Admin.
          </div>
        </ConfirmModal>
      )}

      {openImport?.type === "IMPORT" && (
        <ImportPdf
          open={openImport.open}
          data={openImport?.data}
          handleClose={toggleImport}
          reRender={reRender}
          uploadedCount={uploadedCount}
        />
      )}

      {addGROpen?.type === "ADD_GR_NUMBER" && (
        <ConfirmModal
          open={addGROpen?.open}
          data={addGROpen?.data}
          handleClose={addGRToggle}
          deleteLoading={loading}
          handleYes={() => {}}
          title={""}
          hideAlert={true}
          deleteTitle=""
          questionText=""
          buttonFooterBlank={true}
        >
          <div className="self-stretch text-center text-zinc-700 text-xl font-semibold mb-3">
            Add GR Number
          </div>

          <Form
            form={form}
            layout="vertical"
            requiredMark="optional"
            onFinish={handleGRNumber}
          >
            <Form.Item
              label="GR Number"
              name="grInput"
              rules={[
                {
                  required: true,
                  message: "Please Enter GR Number",
                },
                {
                  validator: async (_: any, value: string) => {
                    if (!value) return Promise.resolve();

                    const trimmedValue = value.trim();

                    // If value contains a decimal point
                    if (trimmedValue.includes(".")) {
                      return Promise.reject(
                        new Error("Decimal points are not allowed")
                      );
                    }

                    // Check if it's a positive whole number
                    if (!/^\d+$/.test(trimmedValue)) {
                      return Promise.reject(
                        new Error("GR number must be a positive whole number")
                      );
                    }

                    return Promise.resolve();
                  },
                },
              ]}
              style={{ marginBottom: 12 }}
            >
              <Input placeholder="GR Number" allowClear />
            </Form.Item>

            <div className="w-full justify-end flex gap-2 pt-6">
              <Button onClick={() => addGRToggle()} className="cancel_btn">
                Cancel
              </Button>
              <Button type="primary" htmlType="submit" loading={postLoading}>
                Add Now
              </Button>
            </div>
          </Form>
        </ConfirmModal>
      )}

      {viewLoading ? (
        <Loader />
      ) : (
        <CustomTable<GetAllBatchmentPaymentData>
          loading={loading}
          total={Number(allBatchmentPayment?.total)}
          page={Number(allBatchmentPayment?.page)}
          limit={Number(allBatchmentPayment?.limit)}
          handlePagination={handlePagination}
          columns={columns}
          // columns={path === "gr-ops" ? columns2 : columns}
          // dataList={addKeyInArray(allPayment)}
          dataList={
            allBatchmentPayment?.data
              ? addKeyInArray(allBatchmentPayment?.data)
              : []
          }
          // rowSelection={
          //   path === "finance"
          //     ? {
          //         type: "checkbox",
          //         selectedRowKeys: selectedData,
          //         onChange: (key) => {
          //           setSelectedData(key as string[]);
          //         },
          //         // getCheckboxProps: (record) => {
          //         //   return {
          //         //     disabled: record?.status === "invited",
          //         //   };
          //         // },
          //         columnWidth: 40,
          //       }
          //     : undefined
          // }
          // rowSelection={{
          //   type: "checkbox",
          //   selectedRowKeys: selectedData,
          //   onChange: (key) => {
          //     setSelectedData(key as string[]);
          //   },
          //   // getCheckboxProps: (record) => {
          //   //   return {
          //   //     disabled: record?.status === "invited",
          //   //   };
          //   // },
          //   columnWidth: 40,
          // }}
          underTheTableComponent={
            path === "finance" && selectedData?.length ? (
              <div className="pt-4 flex justify-center">
                <div className="text-center custom-form">
                  <h4 className="text-header text-base font-medium mb-3">
                    Are You Sure, You Want to Change Payment Status?
                  </h4>

                  <Space>
                    <Button size="large" className="cancel-btn min-w-[120px]">
                      Cancel
                    </Button>
                    <Button
                      type="primary"
                      // disabled={disabledSubmit || disabled}
                      size="large"
                      htmlType="submit"
                      className="min-w-[120px]"

                      // loading={disabled}
                    >
                      Paid
                    </Button>
                  </Space>
                </div>
              </div>
            ) : undefined
          }
        />
      )}
    </>
  );
}
